export default __webpack_public_path__ + "static/media/calendar.9ed8c572.svg";